import { ActionCreator, on, ReducerTypes } from '@ngrx/store';
import { OfferState } from '../offer.state';
import { applyToPersonWithId } from '../offer.reducer.util';
import { changeBasicInsuranceForPerson, removeBasicInsuranceForPerson } from './actions';

export const basicInsuranceReducers: ReducerTypes<OfferState, ActionCreator[]>[] = [
  on(changeBasicInsuranceForPerson, (offerState, payload) => ({
    ...offerState,
    persons: applyToPersonWithId(payload.personId, offerState.persons, (person) => ({
      ...person,
      basicInsurance: {
        key: payload.basicInsuranceKey,
        franchise: payload.franchise,
        includesAccidentCoverage: payload.includesAccidentCoverage,
        price: undefined,
        medicalOffice: payload.medicalOffice,
      },
      totalPrice: undefined,
    })),
    totalPrice: undefined,
  })),
  on(removeBasicInsuranceForPerson, (offerState, payload) => ({
    ...offerState,
    persons: applyToPersonWithId(payload.personId, offerState.persons, (person) => ({
      ...person,
      basicInsurance: undefined,
      totalPrice: undefined,
    })),
    totalPrice: undefined,
  })),
  on(removeBasicInsuranceForPerson, changeBasicInsuranceForPerson, (offerState) => ({
    ...offerState,
    persons: offerState.persons.map((person) => ({
      ...person,
      supplementaryInsurances: {
        ...person.supplementaryInsurances,
        complementaryViva: undefined,
        outpatientViva: undefined,
        hospitalViva: undefined,
      },
    })),
  })),
];
